<template>
  <div>
    <vx-card>
      <br />

      <list :multiple="false" :seleccionar="false"></list>
    </vx-card>
  </div>
</template>

<script>
import GetImagenes from "@/apollo/queries/imagenes/GetImagenes.gql";
import DeleteBlog from "@/apollo/mutations/blog/DeleteBlog.gql";
import CreateImage from '@/apollo/mutations/imagenes/CreateImage.gql'

/* import SidebarEdit from "@/components/app/imagenes/SidebarEdit"; */
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import List from '@/components/app/imagenes/List'

export default {
  data() {
    return {
      images: [],
      typeSection: "select",
      addNewDataSidebar: false,
      sidebarData: null,
      dropzoneOptions: {
          url: "https://httpbin.org/post",
          thumbnailWidth: 145,
          thumbnailHeight: 145,
          addRemoveLinks: false,
          acceptedFiles: ".jpg, .jpeg, .png",
          dictDefaultMessage: `<p class='text-dark'><i class='fa fa-cloud-upload mr-2'></i> Arrastre imagenes o haga click aquí para seleccionar.</p>
          <p class="text-dark">Archivos permitidos: .jpg, .jpeg, .png</p>
          `
      }
    };
  },
  components: {
    // SidebarEdit,
    vueDropzone: vue2Dropzone,
    List
  },
  methods: {
    setSelectedItem(index) {
      this.sidebarData = this.images[index]

      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    uploadFiles(file) {
        console.log(file)

        this.$apollo.mutate({
          mutation: CreateImage,
          variables: {
            imagen: file
          },
          context: {
            hasUpload: true
          }
        })
        .then(() => {
          // this.$vs.notify({color:'success',title: 'Upload Success',text: 'Imágenes guardadas.'})
          this.getImages()

          // Luego de subir la imagen, se cambia la vista para seleccionar imagen
          this.typeSection = 'select'
        })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>